module.exports = __webpack_public_path__ + "static/media/icon_clear.1d257ec5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_clear.svg
// module id = 738
// module chunks = 0